//奖励类型
export const AWARD_TYPE = {
  COUPONS:0,//立减券
  COUPON_PACKAGE:1,//券包
  SERVICE_COUPON:2,//服务兑换券
  FULL_REDUCTION:3, //满减券
  BONUS_POINTS:4 //奖励积分
}



// WEBPACK FOOTER //
// ./src/enum/index.js